<div class="auth-sso-mobile-container">
  <mat-card>
    <main class="auth-sso-mobile-p-sm">
      <h3>Sign in options</h3>
      <div *ngIf="isLoading">
        Checking providers
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      </div>
      <div class="option-container" *ngIf="!isLoading">
        <mat-card class="option-card" *ngFor="let option of options">
          <mat-card-actions (click)="goToProvider(option)">
            <img
              *ngIf="option.logo"
              [src]="'url(' + option.logo + ')'"
              [style.backgroundImage]="'url(' + option.logo + ')'"
            />
            <mat-card-content class="option-card__media-content--with-title">
              <div class="option-card__media-title" mdcSubtitle2>{{ option.name }}</div>
            </mat-card-content>
          </mat-card-actions>
        </mat-card>
      </div>
    </main>
  </mat-card>
</div>
